<template>
  <div class="wrap">
    <div id="primary" class="content-area">
      <main class="site-main" role="main">
        <article class="page type-page status-publish hentry">
          <div class="entry-content">
            <div class="leecho-container">
              <div class="leecho-header">
                <h1 class="leecho-title">{{ $t('leecho.title') }}</h1>
                <p class="leecho-subtitle">{{ $t('leecho.subtitle') }}</p>
              </div>

              <div class="leecho-description">
                <p>{{ $t('leecho.description') }}</p>
              </div>

              <div class="leecho-features">
                <div class="feature-item">
                  <div class="feature-icon">🎤</div>
                  <h3>{{ $t('leecho.feature1.title') }}</h3>
                  <p>{{ $t('leecho.feature1.description') }}</p>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">👁️</div>
                  <h3>{{ $t('leecho.feature2.title') }}</h3>
                  <p>{{ $t('leecho.feature2.description') }}</p>
                </div>
                <div class="feature-item">
                  <div class="feature-icon">🌟</div>
                  <h3>{{ $t('leecho.feature3.title') }}</h3>
                  <p>{{ $t('leecho.feature3.description') }}</p>
                </div>
              </div>

              <div class="leecho-download">
                <h2>{{ $t('leecho.download.title') }}</h2>
                <div class="download-buttons">
                  <a :href="iosDownloadUrl" target="_blank" class="download-button ios">
                    <div class="button-icon"><img :src="appleIcon" alt="iOS"></div>
                    <div class="button-content">
                      <span class="button-label">{{ $t('leecho.download.ios_label') }}</span>
                      <span class="button-text">{{ $t('leecho.download.ios_text') }}</span>
                    </div>
                  </a>
                  <a :href="androidDownloadUrl" target="_blank" class="download-button android">
                    <div class="button-icon"><img :src="androidIcon" alt="Android"></div>
                    <div class="button-content">
                      <span class="button-label">{{ $t('leecho.download.android_label') }}</span>
                      <span class="button-text">{{ $t('leecho.download.android_text') }}</span>
                    </div>
                  </a>
                </div>
              </div>

              <div class="leecho-agreement">
                <p>
                  {{ $t('leecho.agreement.prefix') }}
                  <a :href="userAgreementUrl" target="_blank" rel="noopener"
                     class="agreement-link"
                  >{{ $t('leecho.agreement.user') }}</a
                  >{{ $t('leecho.agreement.and') }}
                  <a :href="privacyPolicyUrl" target="_blank" rel="noopener"
                     class="agreement-link"
                  >{{ $t('leecho.agreement.privacy') }}</a
                  >
                </p>
              </div>

              <div class="leecho-footer">
                <p>{{ $t('leecho.footer') }}</p>
              </div>
            </div>
          </div>
        </article>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeEcho',
  data() {
    return {
      iosDownloadUrl: 'https://www.pgyer.com/leecho-ios',
      androidDownloadUrl: 'https://www.pgyer.com/leecho-android-n',
      appleIcon: require('@/assets/images/phone/apple.png'),
      androidIcon: require('@/assets/images/phone/android.png')
    };
  },
  computed: {
    lang() {
      let srcLan = this.$i18n.locale;
      if (srcLan.indexOf('en') !== -1) {
        return 'en';
      }
      return 'zh';
    },
    privacyPolicyUrl() {
      return this.lang === 'en'
        ? 'https://le-echo.mltcloud.com/private/privacy_policy_en.html'
        : 'https://le-echo.mltcloud.com/private/privacy_policy.html';
    },
    userAgreementUrl() {
      return this.lang === 'en'
        ? 'https://le-echo.mltcloud.com/private/user_agreement_en.html'
        : 'https://le-echo.mltcloud.com/private/user_agreement.html';
    }
  },
  mounted() {
    document.body.className = "page-template-default page page-one-column colors-light";
  }
};
</script>

<style lang="stylus" scoped>
.leecho-container
  max-width: 1200px
  margin: 0 auto
  padding: 60px 20px

.leecho-header
  text-align: center
  margin-bottom: 60px

.leecho-title
  font-size: 48px
  font-weight: 700
  color: #333
  margin: 0 0 20px 0
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  -webkit-background-clip: text
  -webkit-text-fill-color: transparent
  background-clip: text

.leecho-subtitle
  font-size: 20px
  color: #666
  margin: 0
  line-height: 1.6

.leecho-description
  text-align: center
  margin-bottom: 60px
  padding: 0 40px

  p
    font-size: 18px
    line-height: 1.8
    color: #555
    margin: 0

.leecho-features
  display: grid
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr))
  gap: 30px
  margin-bottom: 60px

.feature-item
  background: #fff
  border-radius: 12px
  padding: 40px 30px
  text-align: center
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08)
  transition: transform 0.3s ease, box-shadow 0.3s ease

  &:hover
    transform: translateY(-5px)
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12)

.feature-icon
  font-size: 48px
  margin-bottom: 20px

.feature-item h3
  font-size: 22px
  font-weight: 600
  color: #333
  margin: 0 0 15px 0

.feature-item p
  font-size: 16px
  color: #666
  line-height: 1.6
  margin: 0

.leecho-download
  text-align: center
  margin-bottom: 60px

  h2
    font-size: 32px
    font-weight: 600
    color: #333
    margin: 0 0 40px 0

.download-buttons
  display: flex
  justify-content: center
  gap: 30px
  flex-wrap: wrap

.download-button
  display: flex
  align-items: center
  padding: 20px 30px
  border-radius: 12px
  text-decoration: none
  transition: transform 0.3s ease, box-shadow 0.3s ease
  min-width: 280px

  &:hover
    transform: translateY(-3px)
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15)

  &.ios
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    color: #fff

  &.android
    background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%)
    color: #fff

.button-icon
  margin-right: 15px
  display: flex
  align-items: center
  justify-content: center

  img
    width: 36px
    height: 36px
    object-fit: contain

.button-content
  display: flex
  flex-direction: column
  align-items: flex-start

.button-label
  font-size: 12px
  text-transform: uppercase
  opacity: 0.9
  margin-bottom: 5px

.button-text
  font-size: 18px
  font-weight: 600

.leecho-agreement
  text-align: center
  margin-bottom: 40px

  p
    font-size: 14px
    color: #888
    margin: 0

  .agreement-link
    color: #0066cc
    text-decoration: none
    font-weight: 500
    transition: color 0.3s ease

    &:hover
      color: #0052a3
      text-decoration: underline

.leecho-footer
  text-align: center
  padding: 40px 20px
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)
  border-radius: 12px

  p
    font-size: 16px
    color: #555
    margin: 0
    line-height: 1.6

@media (max-width: 768px)
  .leecho-container
    padding: 40px 20px

  .leecho-title
    font-size: 36px

  .leecho-subtitle
    font-size: 18px

  .leecho-features
    grid-template-columns: 1fr

  .download-buttons
    flex-direction: column
    align-items: center

  .download-button
    width: 100%
    max-width: 350px

@media (max-width: 480px)
  .leecho-title
    font-size: 28px

  .leecho-description
    padding: 0 10px

  .feature-item
    padding: 30px 20px
</style>